export const headerGlobal = () => {
  let location = window.location.pathname
  if (
    location == '/terminos-y-condiciones' ||
    location == '/politicas' ||
    location == '/politica' ||
    location == '/tyc' ||
    location == '/terminosycondiciones'
  ) {
    let header = document.querySelector('header') as HTMLElement
    header.style.backgroundColor = 'rgb(0, 0, 0, 0.7)'
  }

  if (
    location == '/nuestra-maestria' ||
    location == '/nuestra-maestria/platino' ||
    location == '/nuestra-maestria/clasica'
  ) {
    let container = document.querySelector('.layout-container') as HTMLElement
    container.style.backgroundColor = 'black'
    let htmlContent = document.querySelector('.layout-container') as HTMLElement
    htmlContent.style.backgroundColor = 'black'
  }

  const menuMobile = document.querySelector('.menuMobile')
  console.log(menuMobile)

  if (!menuMobile) return
  // menuMobile.length > 0 && Array.from(menuMobile).map( menuMob => {
  menuMobile.addEventListener('click', e => {
    e.preventDefault()
    let menuItems = document.getElementById('menuItems') as HTMLElement
    let subMenu = document.getElementById('sub') as HTMLElement
    menuItems.classList.toggle('active')
    menuMobile.classList.toggle('active')
    subMenu.classList.toggle('active')
  })

  const header = document.querySelector('.header') as HTMLElement
  window.addEventListener('scroll', function (e) {
    if (window.scrollY >= 200) {
      header.classList.add('bkBlack')
    } else {
      header.classList.remove('bkBlack')
    }
  })
}
